import React, { useEffect, useState } from 'react';
import PageNav from './components/PageNav';
import { asideMenuConfig } from './menuConfig';
import Breadcrumb from '../CjyxLayout/components/Header';
// import utils from '@/common/utils'; // hjyt- 添加
import styles from './index.module.scss';

export default function BasicLayout(props) {
  const category = props.pathname.split('/')[2];
  const currentMenuConfig = asideMenuConfig.find((menuConfig) => menuConfig.category === category);
  const hasBreadcrumb = currentMenuConfig?.hasBreadcrumb;
  const [isShowBreadcrumb, setIsShowBreadcrumb] = useState(false);

  useEffect(() => {
    // if (hasBreadcrumb) {
    //   let currentLevel1Menu = currentMenuConfig.children.find((menu) => menu.path === props.pathname);
    //   if (!currentLevel1Menu) {
    //     currentLevel1Menu = currentMenuConfig.children.find((menu) => menu.children?.some((child) => child.path === props.pathname));
    //   }
    //   const currentLevel2Menu = currentLevel1Menu?.children?.find((child) => child.path === props.pathname);
    //   if (!currentLevel1Menu && !currentLevel2Menu) {
    //     setIsShowBreadcrumb(false);
    //   } else {
    //     setIsShowBreadcrumb(true);
    //     setTimeout(() => {
    //       utils.setBreadcrumb({
    //         name: currentLevel1Menu?.name,
    //         url: currentLevel1Menu?.path,
    //         children: !currentLevel2Menu ? undefined : {
    //           name: currentLevel2Menu?.name,
    //           url: currentLevel2Menu?.path,
    //         },
    //       });
    //     });
    //   }
    // } else {
    //   setIsShowBreadcrumb(false);
    // }
  }, [props.pathname]);

  return (
    <div className={`${styles.page} crm-douyin-layout`}>
      <div className={styles.sidebar}>
        <PageNav {...props} />
      </div>
      {
        (hasBreadcrumb && isShowBreadcrumb) ? (
          <div className={styles.wrapper}>
            <Breadcrumb />
            <div className={styles.main}>
              {props.children}
            </div>
          </div>
        ) : (
          <div className={styles.container}>{props.children}</div>
        )
      }
    </div>
  );
}
